import { BrowserRouter, Routes, Route } from "react-router-dom";

import { MainContext } from "./utils/main-context/MainContext";

import Header from "./components/header/Index";
import Menu from "./components/menu/Index";
import Footer from "./components/footer/Index";

import Home from "./pages/home/Index";
import Works from "./pages/works/Index";
import NotFound from "./pages/not-found/Index";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <MainContext>
          <Header />
          <Menu />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/work/:id" element={<Works />} />
              <Route path="/*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </MainContext>
      </BrowserRouter>
    </div >
  );
}

export default App;
